import i18n from "app/i18n";

import { DriverPreference } from "../../../api/types/generated-types";

export const mapDriverPreferenceToCopy: Record<DriverPreference, string> = {
  [DriverPreference.Solo]: i18n.t("solo", { ns: "shipper" }),
  [DriverPreference.Team]: i18n.t("team", { ns: "shipper" }),
  [DriverPreference.None]: i18n.t("n/a", { ns: "shipper" }),
};
